import { render, staticRenderFns } from "./IconPagePrev.vue?vue&type=template&id=2af362a4&"
import script from "./IconPagePrev.vue?vue&type=script&lang=js&"
export * from "./IconPagePrev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports